import axios from 'axios'

const API_PATH = 'admins/consignment/products'

const ConsignmentProductsApi = {
  /**
   * Show Brand details by brand_id
   * @param {object} brand - represent Product::Brand
   * @return {object} [::Product::Brand] with brand_classifications
   *
   */
  showBrand: async (brand) => {
    const endpoint = `${API_PATH}/brands/${brand.id}`
    const response = axios.get(endpoint)
    return response
  }
}

export default ConsignmentProductsApi
